import { GENERATE_TIMESHEET_HOURS, GENERATE_TIMESHEET_HOURS_ERROR, GET_TIMESHEET_BULK_LIST, GET_TIMESHEET_BULK_LIST_ERROR, GET_TIMESHEET_HOURS, GET_TIMESHEET_HOURS_ERROR, GET_TIMESHEET_ID, GET_TIMESHEET_ID_ERROR, GET_TIMESHEET_LIST, GET_TIMESHEET_LIST_ERROR, GET_TIMESHEET_STATUS_LIST, GET_TIMESHEET_STATUS_LIST_ERROR, GET_TIMESHEET_WORKER_RATES, GET_TIMESHEET_WORKER_RATES_ERROR, RESET_TIMESHEET_DETAILS, RESET_TIMESHEET_HOUR_DETAILS, RESET_TIMESHEET_STATUS, SAVE_TIMESHEET, SAVE_TIMESHEET_ERROR } from "../../actions/types";

const initialState = {
    timesheetSubList: [],
    timesheetDetail: {},
    //timesheetHoursList: [],
    timesheetSubStatusList: [],
    timesheetActionList: [],
    //timesheetList: [],
    timesheetScheduleList: [],
    timesheetWorkerRates: {},
    //Timesheet - Hours
    timesheetHourDetail: {},
}

export const timesheet = (state = initialState, action) => {
    switch (action.type) {
        case GET_TIMESHEET_ID:
            return {
                ...state,
                timesheetDetail: action.payload.data,
            };
        case GET_TIMESHEET_ID_ERROR:
            return {
                ...state,
                timesheetDetail: {},
            };
        case GET_TIMESHEET_LIST :
            return {
                ...state,
                timesheetSubList: action.payload.data,
            };
        case GET_TIMESHEET_LIST_ERROR:
            return {
                ...state,
                timesheetList: [],
            };
        case GET_TIMESHEET_STATUS_LIST :
            return {
                ...state,
                timesheetSubStatusList: action.payload.data,
            };
        case GET_TIMESHEET_STATUS_LIST_ERROR:
            return {
                ...state,
                timesheetSubStatusList: [],
            };
        
        case GET_TIMESHEET_BULK_LIST:
            return {
                ...state,
                timesheetActionList: action.payload.data,
            }
        case GET_TIMESHEET_BULK_LIST_ERROR:
            return {
                ...state,
                timesheetActionList: [],
            }
        case RESET_TIMESHEET_STATUS:
            return {
                ...state,
                timesheetSubList: [],
                timesheetSubStatusList: [],
                timesheetActionList: [],   
            }
        case GENERATE_TIMESHEET_HOURS:
            return {
                ...state,
                timesheetScheduleList: action.payload.data,
            }
        case GENERATE_TIMESHEET_HOURS_ERROR: 
            return {
                ...state,
                timesheetScheduleList: [],
            }
        
        case GET_TIMESHEET_WORKER_RATES:
            return {
                ...state,
                timesheetWorkerRates: action.payload.data,
            }
        case GET_TIMESHEET_WORKER_RATES_ERROR:
            return {
                ...state,
                timesheetWorkerRates: {},
            }
        case GET_TIMESHEET_HOURS: 
            return {
                ...state,
                timesheetHourDetail: action.payload.data,
            }
        case GET_TIMESHEET_HOURS_ERROR: 
            return {
                ...state,
                timesheetHourDetail: []
            }
        case RESET_TIMESHEET_DETAILS:
            return {
                ...state,
                timesheetDetail: {},
                timesheetScheduleList: [],
            }

        case SAVE_TIMESHEET:
            return {
                ...state,
                timesheetDetail: action.payload.data,
            }
        // case SAVE_TIMESHEET_ERROR:
        //     return {
        //         ...state,
        //         timesheetDetail: {}
        //     }
        case RESET_TIMESHEET_HOUR_DETAILS:
            return {
                ...state,
                timesheetHourDetail: {},
            }

        default:
            return state;
    }
}